export default __webpack_public_path__ + "static/media/pvn-arte-1.b1cc2f30.webp";